import { render, staticRenderFns } from "./CreatePopOrder.vue?vue&type=template&id=88feb458&"
import script from "./CreatePopOrder.vue?vue&type=script&lang=js&"
export * from "./CreatePopOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports